import { render, staticRenderFns } from "./GamificationDashboard.vue?vue&type=template&id=29a1d4dc&scoped=true&"
import script from "./GamificationDashboard.vue?vue&type=script&lang=js&"
export * from "./GamificationDashboard.vue?vue&type=script&lang=js&"
import style0 from "./GamificationDashboard.vue?vue&type=style&index=0&id=29a1d4dc&prod&scoped=true&lang=css&"
import style1 from "./GamificationDashboard.vue?vue&type=style&index=1&id=29a1d4dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a1d4dc",
  null
  
)

export default component.exports